<div class="modal-content">
  <div class="modal-body">
    <!--BEGIN: Close-->
    <div class="btn btn-sm btn-icon btn-active-color-primary position-absolute top-0 end-0 m-2" (click)="dismissModal()">
      <mat-icon>close</mat-icon>
      <!--END: Svg Icon-->
    </div>
    <!--END: Close-->
    <div class="d-flex flex-column flex-center mb-5">
      <i class="bi bi-exclamation-circle text-danger fs-1" ></i>
      <h2 class="font-weight-bolder my-5">
        @if (_isOverride === false) {
          Delete
        }
        @if (_isOverride) {
          Create
        } Override</h2>


        <!--begin::Title-->
        @if (_isOverride) {
          <h3 class="fw-bold mb-5">
            <form [formGroup]="createScheduleOverrideForm">
              <!--begin::Monitoring Hours-->
              <div class="row mb-2">
                <mat-form-field class="w-400px">
                  <mat-label>Override Type</mat-label>
                  <mat-select formControlName="monitoringHours" placeholder="Select option">
                    @for (select of addRemoveList; track select) {
                      <mat-option [value]="select.id">
                        {{select.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <!--end::Monitoring Hours-->
              <!--begin::From Date-->
              @if (createScheduleOverrideForm.value.allDay === false) {
                <div class="row mb-2">
                  <mat-form-field class="w-100">
                    <mat-label>From</mat-label>
                    <input formControlName="from" type="datetime-local" matInput #input>
                  </mat-form-field>
                </div>
              }
              <!--end::From Date-->
              <!--begin::To Date-->
              @if (createScheduleOverrideForm.value.allDay === false) {
                <div class="row mb-2">
                  <mat-form-field class="w-100">
                    <mat-label>To</mat-label>
                    <input formControlName="to" type="datetime-local" matInput #input>
                  </mat-form-field>
                </div>
              }
              <!--end::To Date-->
              <!--begin::All Day-->
              <div class="row mb-2">
                <mat-slide-toggle class="w-100 me-4" formControlName="allDay">
                  All Day
                </mat-slide-toggle>
              </div>
              <!--end::All Day-->
            </form>
          </h3>
        }
        <!--end::Title-->

        <!--begin::Content-->
        <div class="mb-9 text-dark">
          Are you sure you want to
          @if (_isOverride === false) {
            delete
          }
          @if (_isOverride) {
            override
          }
          this event?
        </div>
        <!--end::Content-->

        <!--begin::Buttons-->
        <div class="d-flex flex-center flex-wrap">
          <a class="btn btn-secondary me-4" (click)="dismissModal()">Cancel</a>
          <a class="btn btn-danger" (click)="closeModal()">
            @if (_isOverride === false) {
              Delete
            }
            @if (_isOverride) {
              Override
            }
          </a>
        </div>
        <!--end::Buttons-->

      </div>
    </div>
  </div>
